export const ALL_NOTES_SIDEBAR = 'edit-post/collab-history-sidebar';
export const NOTE_FORMAT_NAME = 'core/note';
